import {API, Setup} from '../../Services';


async function ReportData(page=1){
    let mallId= localStorage.getItem('mallId');
    let token =  localStorage.getItem('token');

    return API.get(`/payments/invoices`,{
        headers: { 'Authorization':  `Bearer ${token}`},
        params : {
            mall_uid:mallId?mallId:Setup.default_malls,
            page:page
        }
    });
}

// async function FactorData(factorId){
//     let token =  localStorage.getItem('token');
//     return API.get(`/payments/invoices/${factorId}`,{ headers: { 'Authorization':  `Bearer ${token}`} });
// }


export {ReportData};
